"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Phone, CalendarCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToSchedule() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Handy Heroes - Plumbing Services",
    "telephone": "(470) 847-9076",
    "url": "https://handyheroesatl.com/plumbing-services/",
    "areaServed": ["Atlanta", "Alpharetta", "Marietta", "Gwinnett", "Cobb"],
    "description": "Connecting homeowners with independent local plumbers in Atlanta."
  };
  return <section id="readytoschedule" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <div ref={ref} className={`relative overflow-hidden rounded-2xl bg-primary px-6 py-12 text-center shadow-xl transition-all duration-700 ease-out md:px-12 md:py-16 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <div className="relative z-10 flex flex-col items-center">
            <h2 className="font-default mb-4 text-3xl font-bold text-primary-foreground md:text-4xl lg:text-5xl">
              Ready to Schedule?
            </h2>
            <p className="mb-8 max-w-2xl text-lg text-primary-foreground/90 md:text-xl">
              Ask your pro about availability. Quotes provided before work starts.
            </p>

            <div className="flex w-full flex-col justify-center gap-4 sm:w-auto sm:flex-row">
              <Button asChild size="lg" variant="secondary" className="h-12 w-full px-8 text-base sm:w-auto">
                <Link to="#bookingrequest">
                  <CalendarCheck className="mr-2 size-5" />
                  Request a Quote
                </Link>
              </Button>
              <Button asChild size="lg" variant="outline" className="h-12 w-full border-primary-foreground bg-transparent px-8 text-base text-primary-foreground hover:bg-primary-foreground hover:text-primary sm:w-auto">
                <a href="tel:+14708479076">
                  <Phone className="mr-2 size-5" />
                  Call (470) 847-9076
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(schemaData)
    }} />
    </section>;
}